import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 隐藏loading提示框
export function hideLoading(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.HIDE_LOADING, option);
}
